import React, { Suspense, useEffect } from "react";
import { Loader2 } from "lucide-react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingCallButton from "./FloatingCallButton";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1" data-testid="main-content">
        <Suspense fallback={<div className="py-32 flex justify-center" data-testid="page-loading"><Loader2 className="animate-spin text-[#072135]" size={32} /></div>}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <FloatingCallButton />
    </div>
  );
}
